import SimulationDeployed from './SimulationDeployed';
import SimulationProcessData from './SimulationProcessData';
import SimulationSort from './SimulationSort';

function SimulationSandboxData(
    chartType: RulePerformanceChartType,
    filterView: FilterViewOptions,
    sortType: SortType,
    formValues?: ProcessedSimulationReportFormValues,
    sandboxData?: SimulationQueryResponse,
    compareData?: SimulationQueryResponse
) {
    const countResult = sandboxData?.countResult;
    const deployedCountResult = compareData?.countResult;
    const sandboxResultSet = sandboxData?.resultSet?.tablePivot();
    const deployedResultSet = compareData?.resultSet?.tablePivot();
    const isLoading = sandboxData?.isLoading;
    const pivotCount = countResult && countResult.resultSet?.tablePivot();
    const deployedCount = deployedCountResult?.resultSet?.tablePivot() || [];
    const totalSandBoxTransactions = pivotCount?.[0]?.['SimulationTpp.uniqueTransactionCount']
        ? Number(pivotCount?.[0]?.['SimulationTpp.uniqueTransactionCount'])
        : 0;
    const totalDeployedTransactions = deployedCount?.[0]?.['SimulationTpp.uniqueTransactionCount']
        ? Number(deployedCount?.[0]?.['SimulationTpp.uniqueTransactionCount'])
        : 0;
    const totalRejectedTransactions = pivotCount?.[0]?.['SimulationTpp.uniqueRejectedCount']
        ? Number(pivotCount?.[0]?.['SimulationTpp.uniqueRejectedCount'])
        : 0;
    const differenceResultSet = deployedResultSet?.length
        ? sandboxResultSet
              ?.filter((result) => !deployedResultSet?.includes(result))
              .concat(deployedResultSet.filter((depResult) => !sandboxResultSet?.includes(depResult)))
        : [];
    if (differenceResultSet?.length) {
        differenceResultSet?.forEach((result) => {
            const rule = result['SimulationTpp.rule'];
            const diffObjectResult = {
                'SimulationTpp.rule': rule,
                'SimulationTpp.count': '0',
                'SimulationTpp.matches': '0',
                'SimulationTpp.matchesAccept': '0',
                'SimulationTpp.matchesRejectRules': '0'
            };
            if (!sandboxResultSet?.some((item) => item['SimulationTpp.rule'] === rule)) {
                sandboxResultSet?.push(diffObjectResult);
            } else {
                deployedResultSet?.push(diffObjectResult);
            }
        });
    }

    const { deployedData, deployedRejectedTransactions, deployedTotalRejectedMatches } = SimulationDeployed(
        chartType,
        formValues,
        totalDeployedTransactions,
        compareData,
        deployedResultSet
    );

    const sandBoxProcessedData = SimulationProcessData(
        sandboxResultSet,
        totalSandBoxTransactions,
        chartType,
        formValues,
        deployedData
    );

    let sortedProcessData = SimulationSort(sortType, sandBoxProcessedData.processedData, chartType, deployedData);

    if (countResult && countResult.isLoading) {
        return {
            isLoading: true,
            processedData: sandBoxProcessedData?.processedData,
            totalRejectedTransactions,
            totalRejectedMatches: sandBoxProcessedData?.totalRejectedMatches,
            deployedRejectedTransactions,
            deployedTotalRejectedMatches,
            totalSandBoxTransactions,
            totalDeployedTransactions
        };
    }
    if (filterView === 'Modified') {
        sortedProcessData = sortedProcessData?.filter((processObject) => processObject.modified === true);
    }
    if (filterView === 'New') {
        sortedProcessData = sortedProcessData?.filter((processObject) => processObject.new === true);
    }
    return {
        isLoading,
        processedData: sortedProcessData,
        totalRejectedTransactions,
        totalRejectedMatches: sandBoxProcessedData.totalRejectedMatches,
        deployedRejectedTransactions,
        deployedTotalRejectedMatches,
        totalSandBoxTransactions,
        totalDeployedTransactions
    };
}
export default SimulationSandboxData;
